<template>
<div>
    <workspace-header :isTpg="isTpg"></workspace-header>

    <div class="workspace-content">
        <location-zone-picker :isTpg="isTpg"></location-zone-picker>
    </div>
</div>
</template>

<script>
import LocationZonePicker from '../../shared/LocationZonePicker.vue';

export default {
  components: { LocationZonePicker },
  props: ['is-tpg'],
};
</script>

<style>

</style>
